import { getOrganizations, type Organizations } from '@/services/organizations';
import { useQuery } from '@tanstack/react-query';

export const useGetOrganizationsApi = () => {
  const query = useQuery<Organizations[]>({
    queryKey: ['organizations'],
    queryFn: async () => {
      const data = await getOrganizations();
      return data;
    },
  });
  return query;
};
